// App icon badge (red bubble) via the Badging API.
// Mirrors the authoritative unread in-app notification count. Works on
// installed PWAs (iOS 16.4+ Home Screen, desktop Chrome/Edge). No-ops where
// unsupported (e.g. most Android).
export const syncAppBadge = (count) => {
  const n = Number(count) || 0;
  try {
    if ("setAppBadge" in navigator) {
      if (n > 0) {
        navigator.setAppBadge(n).catch(() => {});
      } else if ("clearAppBadge" in navigator) {
        navigator.clearAppBadge().catch(() => {});
      }
    }
  } catch (e) {
    /* unsupported */
  }
  // Keep the service worker's persisted counter aligned with the real unread
  // count so that pushes arriving while the app is closed increment correctly.
  try {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready
        .then((reg) => {
          const target = reg.active || navigator.serviceWorker.controller;
          if (target) target.postMessage({ type: "SYNC_BADGE", count: n });
        })
        .catch(() => {});
    }
  } catch (e) {
    /* ignore */
  }
};
